import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MipdDischargeTemplateService {
  mipdDischargeTemplate: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'mipd_discharge_template/list/?';
  private AddRecord = webapi + 'mipd_discharge_template/create';
  private EditRecord = webapi + 'mipd_discharge_template/update';
  private GetRecord = webapi + 'mipd_discharge_template/byid/';
  private DeleteRecord = webapi + 'mipd_discharge_template/delete/';
  private GetRecordbytemplatename = webapi + 'mipd_discharge_template/byname/';
  private GetTemplateList = webapi + 'mipd_discharge_template/templatelist';

  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordServicebytemplatename(id: any) {
    return this.http.get(this.GetRecordbytemplatename + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  gettemplatelist() {
    return this.http.get(this.GetTemplateList)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mipd-discharge-template/mipd-discharge-template.service.ts